import Card from 'scripts/models/api/cards/base/card';

export default Card.extend({
    define: {},
});
